import { User } from './user-auth';

export enum MfaChallengeAction {
  ENABLE_MFA = 'ENABLE_MFA',
  DISABLE_MFA = 'DISABLE_MFA',
  LOGIN = 'LOGIN',
  UPDATE_MY_SETTINGS = 'UPDATE_MY_SETTINGS',
  REMOVE_MY_ACCOUNT = 'REMOVE_MY_ACCOUNT',
}

export interface MfaActionResultMap {
  [MfaChallengeAction.ENABLE_MFA]: unknown;
  [MfaChallengeAction.DISABLE_MFA]: unknown;
  [MfaChallengeAction.LOGIN]: unknown;
  [MfaChallengeAction.UPDATE_MY_SETTINGS]: Partial<User>;
  [MfaChallengeAction.REMOVE_MY_ACCOUNT]: unknown;
}

export interface MfaInitiateOpts {
  action: MfaChallengeAction;
  password?: string;
  metadata?: Record<string, unknown>;
}

export interface MfaValidateOpts {
  action: MfaChallengeAction;
  code: string;
}

export interface MfaInitiateResponse<TAction extends MfaChallengeAction = MfaChallengeAction> {
  smsSent: boolean;
  // Will depend on the action
  result: MfaActionResultMap[TAction];
}

export interface MfaValidateResponse<TAction extends MfaChallengeAction = MfaChallengeAction> {
  success: boolean;

  // Will depend on the action
  result: MfaActionResultMap[TAction];
}

export const MFA_ERROR_CODES = {
  challengeAttemptsExceeded: 'MFA_CHALLENGE_ATTEMPTS_EXCEEDED',
  challengeExpired: 'MFA_CHALLENGE_EXPIRED',
  challengeInvalidCode: 'MFA_CHALLENGE_INVALID_CODE',
  challengeNotFound: 'MFA_CHALLENGE_NOT_FOUND',
  invalidActionMetadata: 'MFA_INVALID_ACTION_METADATA',
  invalidPassword: 'INVALID_PASSWORD',
  invalidPhoneNumber: 'INVALID_PHONE_NUMBER',
  mfaAlreadyDisabled: 'MFA_ALREADY_DISABLED',
  mfaAlreadyEnabled: 'MFA_ALREADY_ENABLED',
  mfaNotEnabled: 'MFA_NOT_ENABLED',
  mfaRequired: 'MFA_REQUIRED',
  unsupportedAction: 'UNSUPPORTED_MFA_ACTION',
  userHasNoPhoneNumber: 'USER_HAS_NO_PHONE_NUMBER',
} as const;
